// extracted by mini-css-extract-plugin
export default {"btn-ok":"Controls--btn-ok--A3dS9","btnOk":"Controls--btn-ok--A3dS9","btn-cancel":"Controls--btn-cancel--kuC8Z","btnCancel":"Controls--btn-cancel--kuC8Z"};